import React from "react";

function isEmpty(val) {

    if (val !== undefined) {
        if (!!val)
            return val;
        else
            return <span>—</span>
    } else {
        return <span>—</span>
    }
}

export default isEmpty;


// WEBPACK FOOTER //
// ./src/Components/Utils/IsEmpty/index.jsx